<template>
    <div>
        <el-dialog
                title="客服咨询"
                :visible.sync="dialogService"
                width="460px">
            <div class="codeList">
                <ul class="flex justify-content">
                    <li class="item">
                        <p class="img"><img src="@/assets/images/code-qy.jpg"></p>
                        <p>企业助手</p>
                    </li>
                    <li class="item">
                        <p class="img"><img src="@/assets/images/code-dr.jpg"></p>
                        <p>达人管家</p>
                    </li>
                </ul>
            </div>
        </el-dialog>
        <!-- <el-dialog
                title="填写加盟信息"
                :visible.sync="dialogVisible"
                width="30%">
            <div class="joinBox">
                <el-form ref="form" :model="form">
                    <el-form-item>
                        <el-input v-model="form.name" placeholder="公司名称"></el-input>
                        <el-input v-model="form.nickname" placeholder="您的称呼"></el-input>
                        <el-input v-model="form.telephone" placeholder="电话号码"></el-input>
                        <el-input v-model="form.area" placeholder="意向加盟区域"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handelJoin">确认提交</el-button>
            </span>

        </el-dialog> -->
        <div :class="isWhite == true ? 'header white-header shadow' :'header'">
            <div class="box1200 clearfix">
                <div class="logo fl"><img src="@/assets/images/logo.png"></div>
                <div class="nav fl">
                    <ul>
                        <li class="item"><router-link to="/addd">网站首页</router-link></li>
                        <li class="item"><router-link to="/list">任务大厅</router-link></li>
                        <!-- 111 -->
                        <li class="item"><router-link to="/investment">招商加盟</router-link></li>
                        <li class="item"><router-link to="/about">关于我们</router-link></li>
                    </ul>
                </div>
                <div class="login-btn fr"><a v-if="!this.$store.state.code  && !this.$store.state.openid" class="goto" @click="login">登录/注册</a></div>
                <div class="login-btn fr"><a v-if="this.$store.state.code  && !this.$store.state.openid" class="goto" @click="login">登录/注册</a></div>
                <div class="tourist fr" v-if="this.$store.state.openid && this.$store.state.user_type === 3 && !this.$store.state.is_auth"><span class="margin-right-10">尊敬的游客，欢迎您来到{{this.$store.state.siteName}}</span><router-link to="/operator" class="goto" style="margin-right:10px;">企业运营登录</router-link><router-link to="/register" class="goto">立即去认证</router-link><span class="loginOut" @click="loginOut">退出</span></div>
                <div class="tourist fr" v-if="this.$store.state.is_auth ===2"><span class="margin-right-10">很抱歉，认证审核不通过，如有疑问请拨打0753-2354999</span><span class="loginOut" @click="loginOut">退出</span></div>
                <div class="tourist fr" v-if="this.$store.state.user_type === 0">
                    <div v-if="this.$store.state.is_auth === 0">
                        <span class="margin-right-10">尊敬的企业，欢迎您来到{{this.$store.state.siteName}}</span><router-link to="/enterprise-register/result" class="goto">查看认证结果</router-link><span class="loginOut" @click="loginOut">退出</span>
                    </div>
                </div>
                <div class="tourist fr" v-if="this.$store.state.user_type === 1">
                    <div v-if="this.$store.state.is_auth === 0 && this.$store.state.auth_type === 0">
                        <span class="margin-right-10">尊敬的达人，欢迎您来到{{this.$store.state.siteName}}</span><router-link to="/daren-register/select" class="goto">培训认证</router-link><span class="loginOut" @click="loginOut">退出</span>
                    </div>
                    <div v-if="this.$store.state.is_auth === 0 && this.$store.state.auth_type === 1">
                        <span class="margin-right-10">尊敬的达人，欢迎您来到{{this.$store.state.siteName}}</span><router-link to="/daren-register/result" class="goto">查看认证结果</router-link><span class="loginOut" @click="loginOut">退出</span>
                    </div>
                </div>
                <div class="logged fr" v-if="this.$store.state.user_type === 0 && this.$store.state.is_auth === 1">
                    <router-link class="user" to="/enterprise/manage"><img :src="enterprise_logo"></router-link>
                    <el-dropdown placement="bottom">
                        <router-link class="name" to="/enterprise/manage">{{ep_name}}<i class="el-icon-arrow-down el-icon--right"></i></router-link>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item><router-link to="/enterprise/info" class="dropItem">企业信息</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/enterprise/order" class="dropItem">我的推广</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/enterprise/balance" class="dropItem">我的余额</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/enterprise/account" class="dropItem">运营账号</router-link></el-dropdown-item>
                            <el-dropdown-item divided><span @click="loginOut" class="dropItem">退出</span></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <router-link to="/enterprise/message">
                        <el-badge class="none" v-if="is_new == 0"><i class="el-icon-message"></i></el-badge>
                        <el-badge is-dot class="newDot" v-if="is_new == 1"><i class="el-icon-message"></i></el-badge>
                    </router-link>
                </div>
<!--                <div class="logged fr" v-if="this.$store.state.user_type === 0 && this.$store.state.is_auth === 1 && this.$store.state.rank === 1">-->
<!--                    <span class="user"><img :src="enterprise_logo"></span>-->
<!--                    <span class="name">{{ep_name}}</span>-->
<!--                    <router-link to="/enterprise/manage" class="goto">管理中心</router-link>-->
<!--                    <span class="loginOut" @click="loginOut">退出</span>-->
<!--                </div>-->
                <div class="logged fr" v-if="this.$store.state.user_type === 1 && this.$store.state.is_auth === 1 && this.$store.state.newbie_task === 0">
                    <span class="user"><img :src="head_img"></span>
                    <span class="name">{{daren_name}}</span>
                    <router-link to="/daren-register/result" class="goto">完成新手任务</router-link>
                    <span class="loginOut" @click="loginOut">退出</span>
                </div>
                <div class="logged fr" v-if="this.$store.state.user_type === 1 && this.$store.state.is_auth === 1 && this.$store.state.newbie_task === 1">
                    <router-link class="user" to="/daren/manage"><img :src="head_img"></router-link>
                    <el-dropdown placement="bottom">
                        <router-link class="name" to="/daren/manage">{{daren_name}}<i class="el-icon-arrow-down el-icon--right"></i></router-link>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item><router-link to="/daren/info" class="dropItem">个人信息</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/daren/order" class="dropItem">我的推广</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/daren/balance" class="dropItem">我的余额</router-link></el-dropdown-item>
                            <el-dropdown-item divided><span @click="loginOut" class="dropItem">退出</span></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <router-link to="/daren/message">
                        <el-badge class="none" v-if="is_new == 0"><i class="el-icon-message"></i></el-badge>
                        <el-badge is-dot class="newDot" v-if="is_new == 1"><i class="el-icon-message"></i></el-badge>
                    </router-link>
<!--                    <span class="name">{{daren_name}}</span>-->
<!--                    <router-link to="/daren/manage" class="goto">管理中心</router-link>-->
<!--                    <router-link to="/daren/message">-->
<!--                        <el-badge style="margin:3px 0 0 10px;" v-if="is_new == 0"><i class="el-icon-message"></i></el-badge>-->
<!--                        <el-badge is-dot style="margin:3px 0 0 10px;" v-if="is_new == 1"><i class="el-icon-message"></i></el-badge>-->
<!--                    </router-link>-->
<!--                    <span class="loginOut" @click="loginOut">退出</span>-->
                </div>
            </div>
        </div>

        <public-header></public-header>

        <home-banner :list="banner"></home-banner>
        <home-about></home-about>
        <home-enterprise></home-enterprise>
        <home-pepole></home-pepole>
        <home-customer></home-customer>
        <home-joinus></home-joinus>
        <public-footer></public-footer>
        <div :class="isShow == true ? 'back-top show' :'back-top'">
            <el-button type="primary" icon="el-icon-headset" circle class="el-bt" @click="dialogService = true"></el-button>
            <el-button icon="el-icon-arrow-up" circle @click="backTop" class="el-bt"></el-button>
        </div>
    </div>
</template>
<script>
    import {homeBanner,epInfo,myDarenInfo,addBusiness,newsData} from '@/config/api.js'
    import HomeBanner from './components/Banner'
    import HomeAbout from './components/About'
    import PublicHeader from '@/components/Header'
    import PublicFooter from '@/components/Footer'
    import HomeJoinus from './components/Joinus'
    import HomeCustomer from './components/Customer'
    import HomeEnterprise from './components/Enterprise'
    import HomePepole from './components/people'
    import axios from 'axios'
    export default {
        name: 'Home',
        inject:['goLogin'],
        data () {
            return {
                banner: [],
                isShow: false,
                isWhite:false,
                dialogService:false,
                ep_name: '',
                enterprise_logo: '',
                daren_name: '',
                head_img: '',
                is_auth: '',
                user_id: null,
                newbie_task: '',
                rank: '',
                auth_type: '',
                dialogVisible: false,
                form: {
                    name: '',
                    nickname: '',
                    telephone: '',
                    area: ''
                },
                is_new: null
            }
        },
        components: {
            HomeBanner,
            HomeAbout,
            HomeEnterprise,
            HomePepole,
            HomeCustomer,
            HomeJoinus,
            PublicFooter,
            PublicHeader
        },
        methods: {
            getMessage () {
                if (this.$store.state.user_type === 0) {
                    let data = {
                        user_type:0,
                        user_id:this.$store.state.user_id,
                    };
                    this.$post(newsData,data)
                        .then(res => {
                            let data = res.data;
                            this.is_new = data.is_new;
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                } else if (this.$store.state.user_type === 1) {
                    let data = {
                        user_type:1,
                        user_id:this.$store.state.user_id,
                    };
                    this.$post(newsData,data)
                        .then(res => {
                            let data = res.data;
                            this.is_new = data.is_new;
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                }

            },
            getHomeInfo () {
                axios.get(homeBanner)
                    .then(this.getHomeInfoSucc)
                    .catch((error) => {
                        window.console.log(error)
                    })
            },
            getHomeInfoSucc (res) {
                res = res.data;
                if (res.result && res.data) {
                    const data = res.data;
                    this.banner = data.banner
                }
            },
            handleScroll () {
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                scrollTop > 480 ? this.isWhite = true : this.isWhite = false;
                scrollTop > 200 ? this.isShow = true : this.isShow = false
            },
            getInfo () {
                if (this.$store.state.user_type === 0) {
                    let data = {
                        ep_id:this.$store.state.user_id,
                        user_type: this.$store.state.user_type,
                    };
                    this.$post(epInfo, data)
                        .then(res => {
                            let data = res.data;
                            this.ep_name = data.name;
                            this.enterprise_logo = data.enterprise_logo;
                            this.is_auth = Number(data.is_auth);
                            this.rank = Number(data.rank);
                            this.$store.commit('changeIsAuth',this.is_auth);
                            this.$store.commit('changeRank',this.rank);
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                } else if (this.$store.state.user_type === 1) {
                    let data = {
                        user_id: this.$store.state.user_id,
                        user_type: this.$store.state.user_type,
                    };
                    this.$post(myDarenInfo, data)
                        .then(res => {
                            let data = res.data;
                            this.daren_name = data.name;
                            this.head_img = data.head_img;
                            this.is_auth = Number(data.is_auth);
                            this.newbie_task = Number(data.newbie_task);
                            this.auth_type = Number(data.auth_type);
                            this.$store.commit('changeAuthType',this.auth_type);
                            this.$store.commit('changeIsAuth',this.is_auth);
                            this.$store.commit('changeNewbieTask',this.newbie_task);
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                }
            },
            loginOut () {
                this.$confirm('确定要退出吗？是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.commit('changeCode' ,'');
                    this.$store.commit('changeAuthToken' ,'');
                    this.$store.commit('changeOpenId' ,'');
                    this.$store.commit('changeUnionId' ,'');
                    this.$store.commit('changeIsAuth' ,NaN);
                    this.$store.commit('changeId' ,NaN);
                    this.$store.commit('changeUserType' ,3);
                    this.$store.commit('changeIsOperater' ,0);
                    this.$store.commit('changeIsPass' ,NaN);
                    this.$store.commit('changeAuthType' ,NaN);
                    this.$store.commit('changeRank' ,NaN);
                    this.$store.commit('changeNewbieTask' ,NaN);
                    this.$store.commit('changeIsAnswer' ,NaN);
                    this.$store.commit('changeIsInfo' ,NaN);
                    this.$store.commit('changeWeChatNumber' ,NaN);
                    this.$store.commit('changeWeChatFriendNum' ,NaN);
                    this.$store.commit('changeSource' ,NaN);
                    this.$store.commit('changeLabel' ,NaN);
                    this.$message({
                        type: 'success',
                        message: '成功退出!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消退出'
                    });
                });
            },
            handelJoin () {
                let data = {
                    name: this.form.name,
                    nickname: this.form.nickname,
                    telephone: this.form.telephone,
                    area: this.form.area,
                };
                this.$post(addBusiness,data)
                    .then(() => {
                        setTimeout(() => {
                            this.$message.success('提交成功，我们会有工作人员与您联系，请保持电话畅通');
                        }, 1000);
                    })
                    .catch(err => {
                        window.console.log(err);
                        setTimeout(() => {
                            this.$message.error('提交失败，请重新提交');
                        }, 100);
                    })
            },
            backTop() {
                window.scrollTo(0,0);
            },
            login () {
                this.goLogin()
            }
        },
        mounted () {
            this.getInfo();
            this.getHomeInfo();
            this.getMessage();
            window.addEventListener('scroll', this.handleScroll)
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }
</script>
<style scoped>
    .joinBox .title{text-align:center;line-height:80px;font-size:14px;}
    .joinBox .el-input{margin-bottom:22px;}
    .joinBox .el-button{width:100%;}
    .back-top{position: fixed;right:30px;bottom:30px;z-index: 99;display: none;width: 60px;height: 150px;}
    .show{display: block;}
</style>
